// removed by extract-text-webpack-plugin
module.exports = {"inselect":"inselect__3-NTb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InlineSelect/styles.scss
// module id = 2132
// module chunks = 1